


































import { Component, Vue, Prop } from 'vue-property-decorator';
import { IUser, IProject } from '@/lib/interfaces';
import { mapState } from 'vuex';

@Component({
  computed: mapState(['users']),
})
export default class ProjectRow extends Vue {
  /** users from vuex */
  public users!: { string: IUser };

  @Prop() private project!: IProject;
  @Prop({ type: Boolean }) private isFavorite!: boolean;

  private onClickFav() {
    this.$emit('clickFav', this.project, !!this.isFavorite);
  }
}
